<script>
export default {
  methods: {
    clickTrigger(e) {
      e.stopPropagation();
      if (this.showToggle === true || !this.$refs.tooltip) {
        this.clickOutside();
        return;
      }
      let contentContainer = this.targetEl.parentElement;
      let matchFuncName = contentContainer['matches'] ? 'matches' : 'msMatchesSelector';
      if (!(this.$el.parentElement && this.$el.parentElement[matchFuncName]('.lego-tooltip-outer-invisible-container'))) {
        while (
          contentContainer &&
          !(
            contentContainer[matchFuncName](this.contentContainer) ||
            contentContainer.classList.contains('lego-screen')
          )
        ) {
          contentContainer = contentContainer.parentElement || undefined;
        }
        if (!contentContainer) {
          contentContainer = document.body;
        }
        let childNodes = contentContainer.children;
        let outerContainer;
        for (let node of childNodes) {
          if (node.classList.contains('lego-tooltip-outer-invisible-container')) {
            outerContainer = node;
            break;
          }
        }
        if (!outerContainer) {
          outerContainer = document.createElement('div');
          outerContainer.className = 'lego-tooltip-outer-invisible-container';
          contentContainer.insertBefore(outerContainer, contentContainer.firstChild);
          outerContainer.appendChild(this.$el);
        } else {
          outerContainer.appendChild(this.$el);
        }
      } else {
        contentContainer = this.$el.parentElement.parentElement;
      }
      let scrollContainer = contentContainer;
      while (
        scrollContainer &&
        !(
          scrollContainer[matchFuncName](this.scrollContainer) ||
          scrollContainer.classList.contains('lego-system')
        )
      ) {
        scrollContainer = scrollContainer.parentElement || undefined;
      }
      if (!scrollContainer) {
        scrollContainer = document.body;
      }

      let positionLimit = scrollContainer.getBoundingClientRect();
      let target = this.targetEl.getBoundingClientRect();
      let container = this.$el.getBoundingClientRect();
      let tooltip = this.$refs.tooltip.getBoundingClientRect();
      let arrowWidth = !this.$slots.tooltip ? 9 : 0;

      this.computedAnchorStyle = this.getAnchorStyle(
        positionLimit,
        target,
        container,
        tooltip,
        arrowWidth
      );
      this.computedTooltipStyle = this.getToolTipStyle(positionLimit, target, tooltip, arrowWidth);

      // To replace "width: max-content" in IE
      if (this.$refs.tooltipContent.offsetWidth < this.$refs.tooltipContent.scrollWidth) {
        this.$refs.tooltipContent.style.width = this.maxWidth + 'px';
        this.multiline = true;
      }

      this.open();
    },
    getToolTipStyle(parent, target, tooltip, arrowWidth) {
      let tooltipStyle = {};
      if (this.location === 'left') {
        tooltipStyle.right = arrowWidth + 'px';
        if ((target.top + target.bottom) / 2 + tooltip.height - 12 > parent.bottom) {
          tooltipStyle.bottom = (target.top + target.bottom) / 2 - parent.bottom + 'px';
        } else {
          tooltipStyle.top = '-14px';
        }
      } else if (this.location === 'right') {
        tooltipStyle.left = arrowWidth + 'px';
        if ((target.top + target.bottom) / 2 + tooltip.height - 12 > parent.bottom) {
          tooltipStyle.bottom = (target.top + target.bottom) / 2 - parent.bottom + 'px';
        } else {
          tooltipStyle.top = '-14px';
        }
      } else if (this.location === 'top') {
        tooltipStyle.bottom = arrowWidth + 'px';
        if ((target.left + target.right) / 2 - tooltip.width / 2 < parent.left) {
          tooltipStyle.left = parent.left - (target.left + target.right) / 2 + 'px';
        } else if ((target.left + target.right) / 2 + tooltip.width / 2 > parent.right) {
          tooltipStyle.right = (target.left + target.right) / 2 - parent.right + 'px';
        } else {
          tooltipStyle.left = -tooltip.width / 2 + 'px';
        }
      } else {
        tooltipStyle.top = arrowWidth + 'px';
        if ((target.left + target.right) / 2 - tooltip.width / 2 < parent.left) {
          tooltipStyle.left = parent.left - (target.left + target.right) / 2 + 'px';
        } else if ((target.left + target.right) / 2 + tooltip.width / 2 > parent.right) {
          tooltipStyle.right = (target.left + target.right) / 2 - parent.right + 'px';
        } else {
          tooltipStyle.left = -tooltip.width / 2 + 'px';
        }
      }
      return tooltipStyle;
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-tooltip {
  border: 1px solid $color--ui-01;
  padding: 6px 10px;
  line-height: 18px;
  width: max-content;
  white-space: pre-wrap;
  border-radius: 4px;
  display: block;
}
.lego-tooltip-anchor__arrow--right::before {
  left: 1px;
}
.lego-tooltip-anchor__arrow--left::before {
  right: 1px;
}
.lego-tooltip-anchor__arrow--top::before {
  bottom: 1px;
}
.lego-tooltip-anchor__arrow--bottom::before {
  top: 1px;
}
.lego-tooltip-anchor::before {
  z-index: 1001;
}
*[tooltip]:hover::after {
  line-height: 26px;
  background-color: $color--ui-01;
  max-width: $lego-tooltip__max-width;
  padding: 0 8px;
  font-style: normal;
}
</style>
